import { Link } from 'react-router-dom';
import SectionHeading from '@/components/feature/SectionHeading';
import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="bg-background-100 py-16 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-8">
        <SectionHeading
          eyebrow="Topics"
          title="五个主题，五个切口"
          desc="每个分类都有自己的拆解角度。选一个你关心的话题，从证据链开始看起。"
        />

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {categories.map((cat, index) => (
            <Link
              key={cat.id}
              to={`/topics?cat=${cat.id}`}
              className={`group relative flex min-h-[200px] flex-col justify-between overflow-hidden rounded-lg p-6 ${
                index === 0 ? 'sm:col-span-2 lg:col-span-1' : ''
              }`}
            >
              <div className="absolute inset-0 h-full w-full">
                <img
                  src={cat.cover}
                  alt={`${cat.name} - 爆料看料主题分类`}
                  title={`${cat.name} - 爆料看料`}
                  className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-foreground-950/60 transition-colors group-hover:bg-foreground-950/50" />
              </div>
              <div className="relative z-10 flex items-center justify-between">
                <span className="font-heading text-lg font-bold text-background-50">{cat.name}</span>
                <span className="rounded-full bg-background-50/90 px-3 py-1 text-xs font-medium text-foreground-900">
                  {cat.count} 篇
                </span>
              </div>
              <p className="relative z-10 mt-4 text-sm leading-relaxed text-background-200">{cat.desc}</p>
            </Link>
          ))}

          <div className="flex min-h-[200px] flex-col justify-between rounded-lg border border-dashed border-background-400 bg-background-50 p-6">
            <span className="flex h-11 w-11 items-center justify-center rounded-md bg-primary-100 text-primary-700">
              <i className="ri-lightbulb-flash-line text-xl" />
            </span>
            <div>
              <h3 className="font-heading text-base font-bold text-foreground-950">没找到想看的？</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                把你关心的线索发给我们，编辑部会评估信息完整度，合适的选题会排进深扒计划。
              </p>
              <a
                href="#subscribe"
                className="mt-4 inline-flex items-center gap-2 text-sm font-medium text-primary-700 hover:text-primary-600"
              >
                提交线索
                <i className="ri-arrow-right-line" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}